import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { Subscription } from 'rxjs';

import { WebAccessService } from '@commons/services/web.access/web-access.service';
import { Vehicle } from '@commons/models/domain/Vehicle';
import { IVirtualSentGeoStatus } from '@src/app/interfaces/vehicle.interface';
import { SentGeoStatus } from '@commons/enums/sent-geo-status.enum';
import { calculateDateLastUpdate } from '@src/app/utils/last-update';
import { MatDialog } from '@angular/material/dialog';
import { SentDisableModalComponent } from './sent-disable-modal/sent-disable-modal.component';

@Component({
  selector: 'app-sent-tab',
  templateUrl: './sent-tab.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./sent-tab.component.scss'],
})
export class SentTabComponent implements OnInit, OnDestroy {

  @Input('vehicleData') public set setVehicleData(data: Vehicle) {
    this._vehicleData = data;
    this.setVirtualSentGeoStatus();
    this.setServiceSENTStatus();

    if (this.isActiveSENTGeo && this.isFirstInit) {
      this.isFirstInit = false;
      this.getSENTGeoSendingStatus();
    }
  }

  public _vehicleData: Vehicle;
  public virtualSentGeoStatus: IVirtualSentGeoStatus;
  public isActiveSENTGeo: boolean;
  public isLoadingSENTGeoActiveStatus: boolean = true;
  public isSending: boolean;
  public isTheProcessOfSwitchingOn: boolean; // zmieniono switch na true
  public isFirstInit: boolean = true;
  public lastUpdated?: number;

  private readonly ComponentSubsc: Subscription = new Subscription();
  public readonly SENT_GEO_STATUS = SentGeoStatus;

  private get vehicleId(): number {
    return this._vehicleData.Id;
  }

  public get SentGeoCurrentState(): SentGeoStatus {
    return this.virtualSentGeoStatus?.LV.V;
  }

  constructor(
    private webAccessService: WebAccessService,
    private changeDetRef: ChangeDetectorRef,
    public dialog: MatDialog,
  ) {
  }

  ngOnInit(): void {

  }

  ngOnDestroy(): void {
    this.ComponentSubsc.unsubscribe();
  }

  public copyText(text: string): void {
    navigator.clipboard.writeText(text);
  }

  public copyAll(): void {
    navigator.clipboard.writeText(`NR: ${ this._vehicleData.BN }, PIN: ${ this._vehicleData.DP }`);
  }

  public onSwitchChangeValue(): void {
    this.changeSwitchLoading(true);
    this.onSetNewSendingValue();
  }

  public showModalConfirmUnLock(): void {
    const dialog = this.dialog.open(SentDisableModalComponent, { width: '100%', height: '100%', maxWidth: '100%' });
    const sub = dialog.afterClosed().subscribe(
      (res) => {
        if (res) {
          this.isSending = false;
          this.onSwitchChangeValue();
          return;
        }
      }
    );
    this.ComponentSubsc.add(sub);
  }

  public getSENTGeoSendingStatus(): void {
    const sub = this.webAccessService.GetSendToSentGeo(this.vehicleId).subscribe({
      next: ({ SendToSentGeo }) => {
        this.isSending = SendToSentGeo;
        this.isLoadingSENTGeoActiveStatus = false;
        this.changeDetRef.markForCheck();
      }
    });
    this.ComponentSubsc.add(sub);
  }

  private setVirtualSentGeoStatus(): void {
    this.virtualSentGeoStatus = this._vehicleData.ControlIndicators?.find(item => item.Tp === 1005) as IVirtualSentGeoStatus;
    if (this.virtualSentGeoStatus?.LV) {
      this.lastUpdated = calculateDateLastUpdate(this.virtualSentGeoStatus.LV.T);
      this.changeDetRef.markForCheck();
    }
  }

  private setServiceAsOff(): void {
    this.isActiveSENTGeo = false;
    this.isLoadingSENTGeoActiveStatus = false;
    this.changeDetRef.markForCheck();
  }

  private setServiceSENTStatus(): void {
    if (this._vehicleData?.RS) {
      this.isActiveSENTGeo = true;
      return;
    }
    this.setServiceAsOff();
  }

  private onSetNewSendingValue(): void {
    const sub = this.webAccessService.SetSendToSentGeo({ IdVehicle: this.vehicleId, SendToSentGeo: this.isSending }).subscribe(
      () => {
        this.changeSwitchLoading(false);
      }
    );
    this.ComponentSubsc.add(sub);
  }

  private changeSwitchLoading(value: boolean): void {
    this.isTheProcessOfSwitchingOn = value;
    this.changeDetRef.markForCheck();
  }

}
